import React from "react";

import {
  Section,
  Stack,
  Box,
  Columns,
  Column,
  Hidden,
  Text,
  Heading,
} from "@origin-digital/ods-core";
import {
  IIconProps,
  DescriptionIcon,
  CreditCardIcon,
  QuestionMarkOutlineIcon,
} from "@origin-digital/icon";

import {
  AssignmentIcon,
  SunnyOutlineIcon,
  LocalShippingIcon,
} from "../../components/Icons";

import content from "./content.json";

export interface IFeatureProps {
  heading: string;
  text: string;
  Icon: React.FC<IIconProps>;
}

const iconMap = {
  description: DescriptionIcon,
  creditCard: CreditCardIcon,
  sunnyOutline: SunnyOutlineIcon,
  questionMarkOutline: QuestionMarkOutlineIcon,
  assignment: AssignmentIcon,
  localShipping: LocalShippingIcon,
};

export const Feature: React.FC<IFeatureProps> = ({ heading, text, Icon }) => (
  <>
    <Hidden above="sm">
      <Columns space="medium">
        <Column width="content">
          <Icon size={24} />
        </Column>
        <Column>
          <Stack space="xsmall">
            <Heading variant="h3">{heading}</Heading>
            <Text>{text}</Text>
          </Stack>
        </Column>
      </Columns>
    </Hidden>

    <Hidden below="md">
      <Box backgroundColor="transparent">
        <Stack space="small">
          <Icon size={48} />
          <Heading variant="h3">{heading}</Heading>
          <Text>{text}</Text>
        </Stack>
      </Box>
    </Hidden>
  </>
);

export const FeatureSection: React.FC = () => {
  return (
    <Section backgroundColor="grey50">
      <Stack
        space={{
          xs: "none",
          sm: "large",
          md: "large",
          lg: "large",
          xl: "large",
        }}
      >
        {content.features.map((features, rowIdx) => (
          <Columns
            collapseBelow="md"
            space={{
              xs: "small",
              sm: "large",
              md: "large",
              lg: "large",
              xl: "large",
            }}
            key={rowIdx}
          >
            {features.map(({ heading, text, icon }, colIdx) => (
              <Column width="1/3" key={colIdx}>
                <Feature heading={heading} text={text} Icon={iconMap[icon]} />
              </Column>
            ))}
          </Columns>
        ))}
      </Stack>
    </Section>
  );
};
